import styled, { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const ArrowButton = styled.a<IWithSize>`
  width: ${({ size }) => (size ? 24 * size : 24)}px;
  height: ${({ size }) => (size ? 24 * size : 24)}px;
  border-radius: 3px;
  cursor: pointer;
  background-color: ${(props: ITheme) =>
    props.theme.colors.palette.pinkishGrey};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${(props: ITheme) =>
      props.theme.colors.palette.slateGrey};
  }
`

export default ArrowButton
